import { useNavigate } from "react-router-dom"
import { NavBar, CoursePage, GetReady, Footer } from "../../Components/ExportComponents"
import "./Cources.css"
import figma from "../../Photos/figma.jpg";
import adobephotoshop from "../../Photos/adobephotoshop.webp"
import { Helmet } from "react-helmet";
const Cources = ({ CoursesDetails }) => {
    const linkTo = useNavigate();
    // console.log(CoursesDetails)

    document.title = "ScaleUp Academy | Cources"
    return (
        <>
            <Helmet>
                {/* ---------- Basic SEO ---------- */}
                <title>Courses | Scaleup Academy - Best IT & Design Training in Pokhara</title>
                <meta
                    name="description"
                    content="Explore top IT and design courses like Web Development, Graphic Design, and Digital Marketing at Scaleup Academy, Pokhara."
                />
                <meta
                    name="keywords"
                    content="Scaleup Academy, IT courses in Pokhara, web development, design training, digital marketing, Pokhara"
                />
                <meta name="author" content="Scaleup Academy" />

                {/* ---------- Open Graph (for Facebook, LinkedIn, etc.) ---------- */}
                <meta property="og:title" content="Courses | Scaleup Academy Pokhara" />
                <meta
                    property="og:description"
                    content="Join Scaleup Academy and learn from expert trainers in Pokhara's best IT and Design courses."
                />
                <meta
                    property="og:image"
                    content="https://scale-upacademy.com/static/media/fullgreen.7b1a9a6d5005f1002ae3.png"
                />
                <meta property="og:url" content="https://scale-upacademy.com/courses" />
                <meta property="og:type" content="website" />

                {/* ---------- Twitter Card (for Twitter/X sharing) ---------- */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Courses | Scaleup Academy" />
                <meta
                    name="twitter:description"
                    content="Explore IT and Design Courses at Scaleup Academy Pokhara."
                />
                <meta
                    name="twitter:image"
                    content="https://scale-upacademy.com/static/media/fullgreen.7b1a9a6d5005f1002ae3.png"
                />

                {/* ---------- Canonical URL ---------- */}
                <link rel="canonical" href="https://scale-upacademy.com/courses" />
            </Helmet>



            <div className="coursesPage">
                <NavBar />
                <CoursePage CoursesDetails={CoursesDetails} />
            </div>
            <GetReady clean={true} />
            <Footer />
        </>
    )
}
export default Cources